import { render, staticRenderFns } from "./homePage.vue?vue&type=template&id=08546b40&scoped=true"
import script from "./homePage.vue?vue&type=script&lang=js"
export * from "./homePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08546b40",
  null
  
)

export default component.exports